<template>
  <div class="serverStatus">
    <OverlayWindow v-show="!reestablished">
      <template v-slot:title>{{ title }}</template>
      <template v-if="isStarting">
        <p>O servidor está a iniciar. Aguarde um momento — a ligação será restabelecida automaticamente.</p>
      </template>
      <template v-else>
        <p>Tal pode acontecer por breves minutos durante actualizações ao software do servidor.</p>
        <p>Se o problema persistir entre em contacto com a assistência técnica.</p>
      </template>
      <p><Loading :inline="true" :text="loadingText" /></p>
      <template v-slot:actions> &nbsp; </template>
    </OverlayWindow>
    <OverlayWindow v-show="reestablished">
      <template v-slot:title>Contacto reestabelecido</template>
      <p>A ligar...</p>
      <template v-slot:actions> &nbsp; </template>
    </OverlayWindow>
  </div>
</template>

<script>
import OverlayWindow from '../OverlayWindow/OverlayWindow.vue'
import { axios } from '../../request'
import Loading from '../LoadingC.vue'

// How often to probe the server root (200 when ready, 503 while booting).
const PROBE_INTERVAL_MS = 3000

export default {
  name: 'ServerStatus',
  data() {
    return {
      reestablished: false,
      probeTimer: null,
      probing: false,
      mode: import.meta.env.VITE_MODE,
    }
  },
  components: { OverlayWindow, Loading },
  computed: {
    serverStatus() {
      return this.$store.state.serverStatus
    },
    isStarting() {
      return this.serverStatus === 'starting'
    },
    title() {
      return this.isStarting ? 'O servidor está a arrancar' : 'Perdido o contacto com o servidor'
    },
    loadingText() {
      return this.isStarting
        ? 'A aguardar que o servidor fique disponível'
        : 'A tentar restabelecer ligação ao servidor'
    },
  },
  methods: {
    // Hit the API root; a 200 means the server is ready again. A 503 (still
    // booting) or a network error rejects, so we simply try again next tick.
    probe() {
      if (this.probing) {
        return
      }
      this.probing = true
      axios
        .get()
        .then(() => this.recover())
        .catch(() => {
          this.probing = false
        })
    },
    recover() {
      if (this.probeTimer) {
        clearInterval(this.probeTimer)
        this.probeTimer = null
      }
      this.reestablished = true
      setTimeout(() => this.finishRecovery(), 500)
    },
    finishRecovery() {
      // Only reload during boot (the app never finished initialising, so there
      // is no in-progress work to lose). Mid-session — or in local dev — recover
      // in place to preserve the user's work (#260). A genuinely new server
      // version is still surfaced by the separate versionMismatch banner.
      if (this.mode !== 'local' && !this.$store.state.appReady) {
        this.reloadPage()
      } else {
        this.$store.dispatch('serverStatus', 'ok')
      }
    },
    reloadPage() {
      location.reload()
    },
  },
  mounted() {
    this.probeTimer = setInterval(this.probe, PROBE_INTERVAL_MS)
  },
  unmounted() {
    clearInterval(this.probeTimer)
  },
}
</script>

<style lang="scss" scoped>
.serverStatus {
  position: relative;
  z-index: 9001; //Over 9000. There's no way that can be right! 😅
}
</style>
